module.exports = __webpack_public_path__ + "img/cd.59d1b0db.svg";